import { connect } from 'react-redux'
import ProductListViewPullMyProductsToOrder from './ProductListViewPullMyProductsToOrder'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewPullMyProductsToOrder)
